import c_3 from "../../assets/audio-screen/unit3/c_3.mp3"
import c_3_1 from "../../assets/audio-screen/unit3_1/c_3_1.mp3"


export const audio3 = [
   {
    'text':'Edward: Chào em, tên em là gì?\nHoa: Chào anh, tên em là hoa, thế còn anh?\nEdward: Tên của tôi là Edwrd, tôi là người Mỹ thế còn em?\nHoa: Em la nguoi Vietnam, anh làm nghề gì ạ?\nEdward: Tôi là bác sĩ, thế còn em?\nHoa: Em là giáo viên.\n',
    'audio': c_3,
  },

];

export const audio3_1 = [
    {
     'text':'Mary: Chào chị, xin lỗi chị làm nghề gì ạ?\nHướng: Tôi là kế toán viên, còn chị, chị làm gì?\nMary: Tôi là quản lý nhân sự.\nHướng: Chị đang làm cho công ty nào ạ?\nMary: Tôi đang làm cho công ty GM. Thế còn chị?\nHướng: Tôi đang làm cho công ty Asian.\n',
     'audio': c_3_1,
   },
 
 ];